import React from "react";
import styles from "./subjects-classes-stat-card.module.css";
import CustomTag from "../../common/custom-tag/custom-tag";
import SVGIcon from "../../constants/SVGIcon";
import { cardColorArr } from "../../constants/common";
import { Button, Dropdown, Menu } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import ProportionBar from "../dual-progress-bar/proportion-bar";

const SubjectsClassesStatCard = ({
  data = {},
  levels,
  total_students,
  total_male,
  total_female,
  total_teachers,
  subject,
  menuItems,
  routine,
  class_name,
  capacity,
  max_capacity,
  colour_code
}) => {
  const randomIndex = Math.floor(Math.random() * cardColorArr.length);

  const getColorIndexFromLevel = (level = "") => {
    let hash = 0;
    for (let i = 0; i < level.length; i++) {
      hash = level.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash) % cardColorArr.length;
  };

  const index = getColorIndexFromLevel(levels);

  const colorStyle = cardColorArr[index];

  const menu = (
    <Menu>
      {Array.isArray(menuItems) && menuItems.length > 0 ? (
        menuItems.map((item, index) => (
          <Menu.Item key={index} onClick={() => item?.onClick(data)}>
            {item?.label}
          </Menu.Item>
        ))
      ) : (
        <Menu.Item disabled>No Menu Items</Menu.Item>
      )}
    </Menu>
  );

  return (
    <div
      className={styles.subjects_stat_card}
      style={{
        background: colour_code ? `${colour_code}1A` : cardColorArr[randomIndex]?.background,
        border: `1px solid ${colour_code ? `${colour_code}66` : cardColorArr[randomIndex]?.border}`,
      }}
    >
      <div className={styles.subjects_stat_card_top}>
        <CustomTag
          text={subject ?? class_name}
          color={colorStyle?.color}
          background={colorStyle?.background}
          borderColor={colorStyle?.border}
        />
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button
            icon={<MoreOutlined style={{ fontSize: "24px" }} />}
            style={{
              border: "none",
              borderRadius: "4px",
              width: "5px",
              padding: "0",
              backgroundColor: "transparent",
              boxShadow: "none",
              cursor: "pointer",
            }}
          />
        </Dropdown>
      </div>
      <div className={styles.subjects_stat_card_middle}>
        <div className={styles.subjects_stat_card_middle_left}>
          <SVGIcon
            name={"person-icon"}
            width={"20"}
            height={"16"}
            className="anticon"
            stroke={"rgba(136, 136, 136, 1)"}
          />
          <span>Teachers: {total_teachers}</span>
        </div>
        <div className={styles.subjects_stat_card_middle_right}>
          <span>M:&nbsp;{total_male}</span>
          <span>F:&nbsp;{total_female}</span>
        </div>
      </div>
      {routine && (
        <div className={styles.routine}>
          Routine:&nbsp;{routine}
        </div>
      )}
      {levels && (
        <div className={styles.subjects_stat_card_bottom}>
          Levels:&nbsp;{levels}
        </div>
      )}
      {(capacity || max_capacity) ? (
        <div>
          <p>
            Capacity: {capacity}/{max_capacity}
          </p>
          <ProportionBar
            value1={Number(capacity)}
            value2={Number(max_capacity) - Number(capacity)}
            color1={"rgba(23, 160, 34, 1)"}
            color2={"rgba(172, 216, 30, 1)"}
          />
        </div>
      ) : null}
    </div>
  );
};
export default SubjectsClassesStatCard;
